// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ImageWithDownload - wrapper, deferred-loading placeholder and download button */

.image-with-download {
    position: relative;
    display: inline-block;
    z-index: auto;
}

.image-with-download--full-width {
    width: 100%;
}

/* Descendant selectors so the sizing keeps winning over caller class names,
   the way the previous inline styles did. An explicit imgStyle still wins. */
.image-with-download > img {
    display: block;
    width: 100%;
}

.image-with-download > img.image-with-download__img--hidden {
    display: none;
}

/* Placeholder shown while the image is off-screen or still downloading.
   It keeps the box size stable and still exposes the alt text. */
.image-with-download__placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    /* Fills the wrapper when the caller sized it, otherwise reserves a
       sensible box so the layout does not jump once the image arrives. */
    height: 100%;
    min-height: 200px;
    padding: 8px;
    box-sizing: border-box;
    background: #333;
    background-image: linear-gradient(100deg, #333 30%, #3d3d3d 50%, #333 70%);
    background-size: 200% 100%;
    animation: image-placeholder-shimmer 1.4s ease-in-out infinite;
    color: rgba(255, 255, 255, 0.6);
    font-size: 0.85rem;
    text-align: center;
    overflow: hidden;
}

.image-with-download__placeholder-label {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
}

@keyframes image-placeholder-shimmer {
    0% {
        background-position: 200% 0;
    }
    100% {
        background-position: -200% 0;
    }
}

@media (prefers-reduced-motion: reduce) {
    .image-with-download__placeholder {
        animation: none;
    }
}

.image-with-download__button {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 28px;
    height: 28px;
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.7);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    color: white;
    cursor: pointer;
    font-size: 1rem;
    transition: background 0.2s, transform 0.2s;
    z-index: 1;
}

.image-with-download__button svg {
    width: 14px;
    height: 14px;
}

/* Hover effects only where a real pointer exists, so touch devices do not
   keep the hovered state after a tap. */
@media (hover: hover) {
    .image-with-download__button:hover {
        background: rgba(76, 175, 80, 0.9);
        transform: scale(1.1);
    }
}

.image-with-download__button:focus-visible {
    outline: 2px solid rgba(76, 175, 80, 0.9);
    outline-offset: 2px;
}

@media (max-width: 768px) {
    .image-with-download__button {
        top: 8px;
        right: 8px;
        width: 36px;
        height: 36px;
        padding: 10px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    }

    .image-with-download__button svg {
        width: 16px;
        height: 16px;
    }
}

@media (prefers-reduced-motion: reduce) {
    .image-with-download__button {
        transition: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/ImageWithDownload.css"],"names":[],"mappings":"AAAA,kFAAkF;;AAElF;IACI,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;6EAC6E;AAC7E;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;iEACiE;AACjE;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX;yEACqE;IACrE,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,0EAA0E;IAC1E,0BAA0B;IAC1B,8DAA8D;IAC9D,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,0CAA0C;IAC1C,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,2CAA2C;IAC3C,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;wCACwC;AACxC;IACI;QACI,kCAAkC;QAClC,qBAAqB;IACzB;AACJ;;AAEA;IACI,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI;QACI,QAAQ;QACR,UAAU;QACV,WAAW;QACX,YAAY;QACZ,aAAa;QACb,wCAAwC;IAC5C;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["/* ImageWithDownload - wrapper, deferred-loading placeholder and download button */\n\n.image-with-download {\n    position: relative;\n    display: inline-block;\n    z-index: auto;\n}\n\n.image-with-download--full-width {\n    width: 100%;\n}\n\n/* Descendant selectors so the sizing keeps winning over caller class names,\n   the way the previous inline styles did. An explicit imgStyle still wins. */\n.image-with-download > img {\n    display: block;\n    width: 100%;\n}\n\n.image-with-download > img.image-with-download__img--hidden {\n    display: none;\n}\n\n/* Placeholder shown while the image is off-screen or still downloading.\n   It keeps the box size stable and still exposes the alt text. */\n.image-with-download__placeholder {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    /* Fills the wrapper when the caller sized it, otherwise reserves a\n       sensible box so the layout does not jump once the image arrives. */\n    height: 100%;\n    min-height: 200px;\n    padding: 8px;\n    box-sizing: border-box;\n    background: #333;\n    background-image: linear-gradient(100deg, #333 30%, #3d3d3d 50%, #333 70%);\n    background-size: 200% 100%;\n    animation: image-placeholder-shimmer 1.4s ease-in-out infinite;\n    color: rgba(255, 255, 255, 0.6);\n    font-size: 0.85rem;\n    text-align: center;\n    overflow: hidden;\n}\n\n.image-with-download__placeholder-label {\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    word-break: break-word;\n}\n\n@keyframes image-placeholder-shimmer {\n    0% {\n        background-position: 200% 0;\n    }\n    100% {\n        background-position: -200% 0;\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .image-with-download__placeholder {\n        animation: none;\n    }\n}\n\n.image-with-download__button {\n    position: absolute;\n    top: 6px;\n    right: 6px;\n    width: 28px;\n    height: 28px;\n    padding: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0, 0, 0, 0.7);\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    border-radius: 50%;\n    color: white;\n    cursor: pointer;\n    font-size: 1rem;\n    transition: background 0.2s, transform 0.2s;\n    z-index: 1;\n}\n\n.image-with-download__button svg {\n    width: 14px;\n    height: 14px;\n}\n\n/* Hover effects only where a real pointer exists, so touch devices do not\n   keep the hovered state after a tap. */\n@media (hover: hover) {\n    .image-with-download__button:hover {\n        background: rgba(76, 175, 80, 0.9);\n        transform: scale(1.1);\n    }\n}\n\n.image-with-download__button:focus-visible {\n    outline: 2px solid rgba(76, 175, 80, 0.9);\n    outline-offset: 2px;\n}\n\n@media (max-width: 768px) {\n    .image-with-download__button {\n        top: 8px;\n        right: 8px;\n        width: 36px;\n        height: 36px;\n        padding: 10px;\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    }\n\n    .image-with-download__button svg {\n        width: 16px;\n        height: 16px;\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .image-with-download__button {\n        transition: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
